import Select from 'react-select'

const SelectMultiForm = (props) => {
    return (
        <div className={props.col || 'col-12'}>
            <div className="mb-20">
                <label
                    htmlFor="Opciones"
                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                    Sucursales
                </label>
                <Select 
                    options={props.datos} 
                    isSearchable={false} 
                    isMulti={props.isMulti ?? true} 
                    onChange={props.change || (() => {})} 
                    placeholder={props.placeholder || ""}
                    value={props.values || []}
                    /* value={valoresD} */
                    styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: props.error?.[props.name] ? 'red' : '',
                          focus: {
                            borderColor: props.error?.[props.name] ? 'red' : '',
                          },
                        }),
                    }}
                />
                {
                    props.error?.[props.name] && (
                        <div className="" style={{color: 'var(--danger-main)', fontSize: '15px',marginTop: '7px'}}>
                            {props.error?.[props.name]}
                        </div>
                    )
                }
            </div>
        </div>
    );
}
 
export default SelectMultiForm;